export default {
  "l10n": {
    "date": {
      "months": {
        "full": ["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],
        "abbr": ["ene.","feb.","mar.","abr.","may.","jun.","jul.","ago.","sep.","oct.","nov.","dic."]
      },
      "days": {
        "full": ["domingo","lunes","martes","miércoles","jueves","viernes","sábado"],
        "abbr": ["do.","lu.","ma.","mi.","ju.","vi.","sá."]
      },
      "patterns": {
        "longDate": "dddd, D MMMM YYYY",
        "dateSlash": "DD/MM/YYYY",
        "dateShort": "dddd D MMMM",
        "dateMedium": "dddd D MMMM - H[:]mm [h]",
        "dateLarge": "dddd D MMMM [a las] HH[:]mm:ss [h]",
        "timeShort": "LT",
        "timeMedium": "DD[/]MM LT"
      }
    },
    "number": {
      "patterns": {
        "standard": ["-n", "n"],
        "amount": ["-nS", "nS"]
      },
      "group": {
        "separator": ".",
        "length": 3,
        "abbr": ["", "k", "M", "B"]
      },
      "decimal": {
        "separator": ",",
        "length": 2
      },
      "ordinal": function(number) { return number + (number === 1 ? '°' : '°'); }
    }
  },
  "translations": {
    "messages": {
  " CASH ": [
    null,
    ""
  ],
  "!action:Deposit": [
    null,
    "Depósito"
  ],
  "!desc:BetRefundOffer": [
    null,
    "Aposta reembolsada até € 100 <br /> <br /> Para celebrar a sua chegada à Winamax, irá beneficiar de duas ofertas de boas-vindas após o seu primeiro depósito: um bónus até € 250 e a sua primeira aposta reembolsada até € 100! <br /> <br /> As duas ofertas podem ser combinadas e são acionadas automaticamente com o seu primeiro depósito. <br /> <br /> Bónus de até € 250 <br /> <br /> Se sua primeira aposta na Winamax não for vencedora, devolveremos o valor do seu primeiro depósito até € 100. <br /> <br /> Por exemplo, se depositar € 50 na Winamax e aposta na vitória do Real Madrid contra o Barcelona. Se o Real Madrid não ganhar, depois de validar a conta (documento de identificação enviado), irá receber € 50 na sua conta Winamax."
  ],
  "!desc:BetRefundOffer100": [
    null,
    "Oferta do primeiro depósito, até 100€ <br /> <br /> Para comemorar a sua chegada à Winamax, irá beneficiar de duas ofertas de boas-vindas quando realizar o seu primeiro depósito: um bónus de até 250€ e a oferta do valor do seu primeiro depósito em Freebets, até € 100€*! Poderá começar a apostar em desportos imediatamente. <br /> <br /> As 2 ofertas são cumulativas e realizadas automaticamente quando fizer o seu primeiro depósito, se assim o desejar."
  ],
  "!desc:CondBetRefundOffer": [
    null,
    "* Antes de qualquer levantamento, o montante de depósito inicial deve ser utilizado em apostas desportivas na Winamax.pt (no limite de 100€ se este for superior) com o seu saldo de dinheiro real. Esta ação pode ser feita ao realizar uma ou várias apostas (exceto Freebets). A apostas canceladas ou apostas Cashout não serão contabilizadas."
  ],
  "!desc:CondFirstDeposit": [
    null,
    "A oferta do primeiro depósito é válida apenas uma vez por utilizador, terminal (computador, tablette ou telefone), domicilio ou conta bancária. Esta é reservada aos jogadores que nunca tenham realizado um depósito numa conta na Winamax (incluindo numa que tenha sido encerrada)"
  ],
  "!desc:DefaultLandingContent": [
    null,
    "<div class=\"hide-for-small\">\n<p> Para celebrar a sua chegada à Winamax, irá beneficiar de duas ofertas de boas-vindas quando fizer o seu primeiro depósito: <b> o montante do seu primeiro depósito em bónus de apostas desportivas até 100 euros </b> e um <b>bónus até 250€!</b>*</p><br />\n<p> As duas ofertas são acumuláveis e, dependendo das suas preferências, ativadas automaticamente quando realizar o seu primeiro depósito. </p><br />\n<p> Está à espera de quê para se registar no site com <b>o melhor bónus de boas-vindas? </b></p><br />\n<h2> Como funciona? </h2>\n<br />\n<p> Quando realizar o seu primeiro depósito na Winamax, e antes de qualquer ação de jogo, oferecemos-lhe o montante do seu depósito em bónus de apostas desportivas até 100 euros. <br />\nPor exemplo, se depositar 100 euros na Winamax, receberá imediatamente 100 euros em bónus de apostas desportivas na sua conta para começar a apostar. <br />\nTambém lhe oferecemos um bónus no valor do seu depósito até 250 euros. A sua conta Winamax será creditada em parcelas de 20% do valor do bónus cada vez que tiver ganho Milhas suficientes (Milhas são pontos de fidelidade obtidos ao jogar poker e/ou realizar apostas desportivas). Por cada euro de bónus, terá de ganhar 30 milhas. Por exemplo, se tiver depositado 100 euros como primeiro depósito, creditar-lhe-emos 20 euros quando atingir 600 Milhas, depois outros 20 euros quando atingir 1.200 Milhas, etc. Receberá um total de 100 euros uma vez que tenha ganho Milhas suficientes. No total, receberá 100 euros após ter obtido 3.000 Milhas.<br />\n<p><small><i>* A oferta de primeiro depósito é válida uma vez por utilizador, terminal (computador, tablet ou smartphone), assinatura de Internet ou conta bancária. A oferta é reservada aos jogadores que nunca tenham realizado um depósito numa conta Winamax (incluindo contas que tenham sido encerradas). <a href=\"/https://www.winamax.pt/bonus-primeiro-deposito\" target=\"_blank\"> Ver todas as condições</i></a>.</small></p>\n</div>\n<div class=\"show-for-small-only\">\n<p> Para celebrar a sua chegada à Winamax, irá beneficiar de duas ofertas de boas-vindas quando realizar o seu primeiro depósito: <b> um bónus até 250 €</b>* e <b> o montante do seu depósito em bónus de apostas desportivas até 100 €!</b>**</p><br />\n<p> As duas ofertas são acumuláveis e, dependendo das suas preferências, ativadas automaticamente quando realizar o seu primeiro depósito. </p><br />\n<p> Está à espera de quê para se registar no site com <b> o melhor bónus de boas-vindas? </b> ?</p><br /><br />\n</div>\n"
  ],
  "!desc:DefaultLandingContentES": [
    null,
    ""
  ],
  "!desc:DefaultLandingMobileContent": [
    null,
    "<h2> Como funciona? </h2>\n<br />\n<p> Quando realizar o seu primeiro depósito na Winamax, e antes qualquer ação de jogo, oferecemos-lhe o montante do seu depósito em bónus de apostas desportivas até 100 €.\n<br />\nPor exemplo, se depositar 100€ na Winamax, receberá imediatamente 100€ em bónus de apostas desportivas na sua conta para começar a apostar.\n<br />\nTambém lhe oferecemos um bónus no valor do seu depósito até 250€. A sua conta Winamax será creditada em parcelas de 20% do valor do bónus cada vez que tiver ganho Milhas suficientes (Milhas são pontos de fidelidade obtidos ao jogar poker e realizar apostas desportivas). Por cada euro de bónus, terá de ganhar 30 milhas. Por exemplo, se tiver realizado o primeiro depósito no valor de 100€, creditar-lhe-emos 20 euros quando atingir 600 Milhas, depois outros 20 euros quando atingir 1.200 Milhas, etc. Receberá um total de 100 euros assim que tiver acumulado Milhas suficientes. No total, receberá 100€ após ter obtido 3.000 Milhas.\n<br /><br />\n<p><small><i>* A oferta de primeiro depósito é válida apenas uma vez por utilizador, terminal (computador, tablet ou smartphone), assinatura de Internet ou conta bancária. A oferta é reservada aos jogadores que nunca fizeram um depósito numa conta Winamax (incluindo contas que tenham sido encerradas). <a href=\"/https://www.winamax.pt/bonus-primeiro-deposito\" target=\"_blank\"> Ver todas as condições </i></a>.</small></p>\n"
  ],
  "!desc:DefaultLandingPageTitleES": [
    null,
    ""
  ],
  "!desc:DefaultLandingTitleES": [
    null,
    ""
  ],
  "!desc:SpecialOfferLandingContent": [
    null,
    ""
  ],
  "!desc:SpecialOfferLandingMobileContent": [
    null,
    ""
  ],
  "!placeholder:dd": [
    null,
    "dd"
  ],
  "!placeholder:mm": [
    null,
    "mm"
  ],
  "!placeholder:yy": [
    null,
    "aa"
  ],
  "!placeholder:yyyy": [
    null,
    "aaaa"
  ],
  ", if you lost": [
    null,
    ""
  ],
  "1st bet refunded up to €100": [
    null,
    "1ª aposta reembolsada até 100€"
  ],
  "A photo of the back of your ID document will also be required to validate your account.": [
    null,
    "Para validar a sua conta, também é necessário que envie um foto do verso do seu documento de identificação."
  ],
  "A receipt for your rent": [
    null,
    "Um comprovativo de pagamento de renda"
  ],
  "Above": [
    null,
    "Superior a"
  ],
  "Acceptable ID": [
    null,
    "ID aceitável"
  ],
  "Acceptable formats: %1$s.": [
    null,
    "Formatos válidos: %1$s."
  ],
  "Acceptable proof of address documents": [
    null,
    "Prova aceitável de documentos de residência."
  ],
  "Account already exist": [
    null,
    "Conta já existente"
  ],
  "Account creation complete": [
    null,
    "Criação de conta completa"
  ],
  "Account creation: complete.<br />That's what<br />we're talking about!": [
    null,
    "Criação de conta: completa.<br />Assim é que <br />é falar!"
  ],
  "Account number": [
    null,
    "Número da conta"
  ],
  "Activation code": [
    null,
    "Código de ativação"
  ],
  "Add a bank card": [
    null,
    "Adicionar cartão bancário"
  ],
  "Add my bank card": [
    null,
    "Adicionar o meu cartão bancário"
  ],
  "Add my bank card details": [
    null,
    "Adicionar informações do meu cartão bancário "
  ],
  "Address details": [
    null,
    "Detalhes da morada"
  ],
  "All countries": [
    null,
    "Todos os países"
  ],
  "An error has occured when checking your CAPTCHA score. Please try again later.": [
    null,
    "Ocorreu um erro ao verificar o seu resultado CAPTCHA. Por favor, tente novamente mais tarde."
  ],
  "Analysis": [
    null,
    "Análise"
  ],
  "Automatic withdrawal": [
    null,
    "Levantamento automático "
  ],
  "Automatic withdrawal threshold": [
    null,
    ""
  ],
  "BOOM! You can start playing!": [
    null,
    "BOOM! Pode começar a jogar!"
  ],
  "Back": [
    null,
    "Voltar"
  ],
  "Back to homepage": [
    null,
    "Voltar à homepage"
  ],
  "Bank": [
    null,
    "Banco"
  ],
  "Bank accounts from this country are not accepted on Winamax": [
    null,
    "As contas bancárias domiciliadas neste país não são aceites na Winamax"
  ],
  "Bank card number": [
    null,
    "Número de cartão bancário"
  ],
  "Bank code": [
    null,
    "Código do banco"
  ],
  "Bank office": [
    null,
    "BIC/SWIFT"
  ],
  "Before any action even made on our site, we offer you your initial deposit in Freebets, up to €100.": [
    null,
    "Antes de realizar qualquer ação no nosso site, oferecemos-lhe o valor do seu depósito inicial em Freebets até 100€."
  ],
  "Beginner": [
    null,
    ""
  ],
  "Beginner profile token": [
    null,
    ""
  ],
  "Beneficiary": [
    null,
    "Beneficiário"
  ],
  "Bet on sports": [
    null,
    "Aposte nos desportos"
  ],
  "Betting limit - Poker": [
    null,
    ""
  ],
  "Betting limit - Sport betting": [
    null,
    ""
  ],
  "Birth date": [
    null,
    "Data de Nascimento"
  ],
  "Birth name": [
    null,
    ""
  ],
  "Bonus up to €250": [
    null,
    "Bónus até 250€ "
  ],
  "Boom!": [
    null,
    "Boom!"
  ],
  "By ticking this box, you agree that you have read and accepted our": [
    null,
    ""
  ],
  "CAPTCHA score error. Please try again. You will automatically be redirected to the Winamax website. (%1$s)": [
    null,
    "Erro CAPTCHA. Por favor, tente novamente. Irá ser automaticamente redirecionado para o site da Winamax. (%1$s)"
  ],
  "Card number": [
    null,
    "Número de cartão"
  ],
  "Change address": [
    null,
    "Alterar endereço"
  ],
  "Change my deposit limit": [
    null,
    "Alterar o meu limite de depósito"
  ],
  "Change my limit": [
    null,
    "Alterar o meu limite"
  ],
  "Change your account details in order to receive your activation code by post.": [
    null,
    "Altere as informações da sua conta de forma a receber o seu código de ativação via correio postal."
  ],
  "Check that your bank card information is accurate and complete the cryptogram.": [
    null,
    "Verifique se as informações do seu cartão bancário estão corretas e complete o criptograma."
  ],
  "Choose a deposit method in order to make your first deposit.": [
    null,
    "Escolha um método de depósito de forma a realizar o seu primeiro depósito "
  ],
  "Choose a deposit method.": [
    null,
    "Escolha um método de depósito."
  ],
  "Choose the amount of your first deposit in order to start playing.": [
    null,
    "Escolha o montante do seu primeiro depósito para começar a jogar."
  ],
  "Choose the amount you wish to deposit in order to continue playing.": [
    null,
    "Escolha o montante que deseja depositar para poder começar a jogar."
  ],
  "Choose the maximum amount you wish to deposit per month.": [
    null,
    ""
  ],
  "Choose the maximum amount you wish to deposit per week.": [
    null,
    "Escolha o máximo que deseja depositar por semana."
  ],
  "Choose the profile that best suits your playing style! You can also change the values manually.": [
    null,
    ""
  ],
  "Choose which bank card you want to use to make a deposit.": [
    null,
    "Escolha o cartão bancário para realizar o depósito."
  ],
  "Choose your country code": [
    null,
    "Escolha o seu código de país"
  ],
  "Choose your limit well in order to take advantage of your <b>first bet refunded up to €100</b>": [
    null,
    "Escolha bem o seu limite de forma a beneficiar totalmente<b> da sua primeira aposta reembolsada até 100€</b>"
  ],
  "Choose your username, but choose well!!<br />You need to have a kick-ass username to stand out in society.": [
    null,
    "Pense bem antes de escolher! <br /> É importante ter um nome de utilizador com estilo para brilhar na sociedade."
  ],
  "City": [
    null,
    "Cidade"
  ],
  "Click & drag your file here": [
    null,
    "Clique e arraste o seu ficheiro para aqui"
  ],
  "Close": [
    null,
    "Fechar"
  ],
  "Come and take a seat": [
    null,
    "Venha e sente-se"
  ],
  "Complete registration now": [
    null,
    ""
  ],
  "Confirm limit": [
    null,
    "Confirmar limite"
  ],
  "Confirm my details": [
    null,
    "Confirmar as minhas informações"
  ],
  "Confirm my limit": [
    null,
    "Confirmar o meu limite"
  ],
  "Confirm your details in order to receive a new activation code by post.": [
    null,
    "Confirme as suas informações de forma a receber um novo código de ativação via correio "
  ],
  "Continue": [
    null,
    "Continuar"
  ],
  "Continue my deposit": [
    null,
    "Continuar o meu depósito"
  ],
  "Continue with PayPal": [
    null,
    "Continuar com PayPal"
  ],
  "Country": [
    null,
    "País"
  ],
  "Country of birth": [
    null,
    "País de nascimento"
  ],
  "Country of residence": [
    null,
    "País de residência"
  ],
  "Create my account": [
    null,
    "Criar a minha conta"
  ],
  "Creation": [
    null,
    "Criação"
  ],
  "Cryptogram": [
    null,
    "Criptograma "
  ],
  "Deposit": [
    null,
    "Depósito"
  ],
  "Deposit limit": [
    null,
    "Limite de depósito "
  ],
  "Deposit on my account": [
    null,
    "Depositar na minha conta"
  ],
  "Deposit on your Winamax account by bank transfer": [
    null,
    "Depósito na sua conta Winamax via transferência bancária"
  ],
  "Deposit on your account with Neteller.": [
    null,
    "Deposite na sua conta via Neteller."
  ],
  "Deposit with Moneybookers/Skrill.": [
    null,
    "Depositar com Moneybookers/Skrill."
  ],
  "Document": [
    null,
    "Documento"
  ],
  "Document number": [
    null,
    "Número de documento"
  ],
  "Don't forget to send us your ID to validate your account and withdraw your winnings.": [
    null,
    ""
  ],
  "Driver's licence": [
    null,
    "Carta de condução"
  ],
  "Driver's license": [
    null,
    "Carta de condução"
  ],
  "Driver's license: whole document with photo or front and back sides": [
    null,
    "Carta de condução: Documento completo com foto, frente e verso."
  ],
  "Edit email/phone number": [
    null,
    "Editar email/número de telefone"
  ],
  "Email": [
    null,
    "Email"
  ],
  "Enter a different amount": [
    null,
    "Introduzir um montante diferente"
  ],
  "Enter amount": [
    null,
    "Introduzir montante"
  ],
  "Enter my information": [
    null,
    "Introduzir os meus dados"
  ],
  "Enter the activation code sent to you by post.": [
    null,
    "Introduza o código de validação que lhe foi enviado via correio postal."
  ],
  "Enter the code sent by text message to %1$s to verify your phone number.": [
    null,
    "Introduza o código que lhe foi enviado via SMS para o %1$s de forma a verificar o seu número de telefone."
  ],
  "Experienced": [
    null,
    ""
  ],
  "Experienced profile token": [
    null,
    ""
  ],
  "Expiry date": [
    null,
    "Data de validade "
  ],
  "Feel free to discover the platform at a later date if you so wish.": [
    null,
    ""
  ],
  "Female": [
    null,
    "Feminino"
  ],
  "Fill in my details": [
    null,
    "Completar os meus dados"
  ],
  "Fill out the following form. Or directly fill out the informations with Paypal": [
    null,
    "Preencha o formulário seguinte. Ou preencha diretamente as suas informações com Paypal"
  ],
  "Fill out the form with your bank card information.": [
    null,
    "Preencha o formulário com as informações do seu cartão bancário"
  ],
  "First deposit": [
    null,
    "Primeiro depósito"
  ],
  "First name": [
    null,
    "Nome"
  ],
  "For a Spanish nationality, you must supply us with a DNI and not a NIE": [
    null,
    ""
  ],
  "For a foreign nationality, you must supply us with a NIE and not a DNI": [
    null,
    ""
  ],
  "Free registration": [
    null,
    "Registo gratuito"
  ],
  "Full name on card": [
    null,
    "Nome completo no cartão"
  ],
  "GG!<br />Your account has<br />been validated!": [
    null,
    "GG!<br />A sua conta foi<br />validada!"
  ],
  "Gambling is prohibited for minors": [
    null,
    "Os jogos de azar são interditos \na menores de 18 anos"
  ],
  "General Terms and Conditions": [
    null,
    "Termos e Condições Gerais "
  ],
  "Health card: front and back": [
    null,
    "Cartão de saúde: frente e verso"
  ],
  "Hold on": [
    null,
    "Aguarde"
  ],
  "I accept the ": [
    null,
    "Eu aceito os "
  ],
  "I agree to gain access to all": [
    null,
    ""
  ],
  "I have not received my code": [
    null,
    "Não recebi o meru código"
  ],
  "I need a new code": [
    null,
    "Necessito de um novo código de validação "
  ],
  "I want to receive offers and news": [
    null,
    ""
  ],
  "I will deposit later": [
    null,
    "Irei depositar mais tarde"
  ],
  "I will send it at a later time": [
    null,
    "Enviar depois "
  ],
  "I would like to receive the newsletter and be kept up to date on all the latest bonuses and promotions": [
    null,
    ""
  ],
  "IBAN": [
    null,
    "IBAN"
  ],
  "ID card: front and back": [
    null,
    "Documento de identificação: frente e verso"
  ],
  "ID card: front side": [
    null,
    "Documento de identificação: Frente"
  ],
  "Identity card": [
    null,
    "Documento de identificação"
  ],
  "Identity not verified": [
    null,
    "Identidade não válida"
  ],
  "If you are not resident in Germany, you can register on": [
    null,
    ""
  ],
  "Important! Make sure you add the folloing reference for your transfer:": [
    null,
    "Importante! Não se esqueça de adicionar a referência seguinte para a sua transferência:"
  ],
  "In 30 seconds": [
    null,
    "Em 30 segundos"
  ],
  "In order to be able to play for real money, you must submit an ID and proof of address.": [
    null,
    ""
  ],
  "In order to make your deposit, add your bank card or any other deposit method.": [
    null,
    "De forma a poder realizar o seu primeiro depósito, adicione o seu cartão bancário ou outro método de depósito."
  ],
  "In order to make your first deposit, add your bank card or any other deposit method.": [
    null,
    "De forma a poder realizar o seu primeiro depósito, adicione o seu cartão bancário ou outro método de depósito."
  ],
  "In order to play for real money, you must send us a proof of address.": [
    null,
    ""
  ],
  "In order to play for real money, you must send us an ID.": [
    null,
    ""
  ],
  "In order to validate your account, you must upload a photo of your ID.": [
    null,
    "De forma a validar a sua conta, tem de enviar uma foto do seu documento de identificação."
  ],
  "Incorrect format in this field": [
    null,
    "Formato incorreto"
  ],
  "Incorrect tax code": [
    null,
    "Número de identificação fiscal incorreto"
  ],
  "Incorrect value in this field, the department does not match the city.": [
    null,
    "Valor incorreto: A cidade não corresponde ao distrito."
  ],
  "Invalid NIE support number format. This must start with the letter \"E\" or \"C\" and be followed by 8 numbers.": [
    null,
    "Formato de número de apoio NIE inválido. Este deve começar com a letra \"E\" ou \"C\" seguido por 8 dígitos."
  ],
  "Invalid phone number format.": [
    null,
    "Formato de número de telefone inválido "
  ],
  "It seems there is a connection problem": [
    null,
    "Existe aparentemente um problema de conexão "
  ],
  "It's time to get serious": [
    null,
    ""
  ],
  "Join Winamax and take advantage of our welcome offer!": [
    null,
    "Junte-se à Winamax e beneficie da nossa oferta de boas-vindas !"
  ],
  "Keep an <br />eye on your<br />dough!": [
    null,
    "Não perca <br />a sua massa<br />de vista!"
  ],
  "Last name": [
    null,
    "Apelido"
  ],
  "Last<br />sprint!": [
    null,
    "Último <br />sprint"
  ],
  "Leave": [
    null,
    "Sair"
  ],
  "Loading...": [
    null,
    "A carregar..."
  ],
  "Log in": [
    null,
    "Log in"
  ],
  "Make a deposit": [
    null,
    "Realizar um depósito"
  ],
  "Male": [
    null,
    "Masculino"
  ],
  "Maximum amount per month": [
    null,
    ""
  ],
  "Maximum amount per week": [
    null,
    "Valor máximo por semana"
  ],
  "Missing application initialization parameters. Please try again.": [
    null,
    "Não foi possível iniciar a aplicação. Tente novamente mais tarde "
  ],
  "Moneybookers email": [
    null,
    "Email Moneybookers "
  ],
  "Must contain at least 3 of the following characters: (0-9), (a-z), (A-Z) and symbols (ex @, !, #, $).": [
    null,
    "Tem de incluir 3 dos seguintes caracteres (0-9), (a-z), (A-Z) e símbolos (ex @, !, #, $)."
  ],
  "NIE number": [
    null,
    "Número de apoio NIE"
  ],
  "Nationality": [
    null,
    "Nacionalidade"
  ],
  "Neteller Secure ID": [
    null,
    "ID de segurança Neteller "
  ],
  "Neteller account": [
    null,
    "Conta Neteller."
  ],
  "No godfather found for this code": [
    null,
    ""
  ],
  "No minors": [
    null,
    "Interdito a menores"
  ],
  "Not connected": [
    null,
    "Não conectado"
  ],
  "Ok": [
    null,
    "Ok"
  ],
  "Oops,": [
    null,
    "Ups,"
  ],
  "Open your account": [
    null,
    "Criação de conta"
  ],
  "Optional": [
    null,
    "Opcional"
  ],
  "Other deposit methods": [
    null,
    "Outros métodos de depósitos"
  ],
  "Other suggestions": [
    null,
    "Outras sugestões"
  ],
  "Our bank details for your transfer:": [
    null,
    "As nossas informações bancárias para realizar a sua transferência:"
  ],
  "Passport": [
    null,
    "Passaporte"
  ],
  "Passport: whole page with photo": [
    null,
    "Passaporte: página inteira com foto"
  ],
  "Password": [
    null,
    "Palavra passe"
  ],
  "Per month": [
    null,
    ""
  ],
  "Per week": [
    null,
    "Por semana"
  ],
  "Personal information": [
    null,
    "Informações pessoais "
  ],
  "Phone number": [
    null,
    "Número de telefone"
  ],
  "Phone, internet, water, gas or electricity bills": [
    null,
    "Faturas de telefone, água, gás, internet e eleticidade"
  ],
  "Place of birth": [
    null,
    "Naturalidade"
  ],
  "Play on the app !": [
    null,
    "Jogue na app!"
  ],
  "Play poker": [
    null,
    "Jogue poker"
  ],
  "Play time - Poker": [
    null,
    ""
  ],
  "Poker Terms and Conditions": [
    null,
    "Termos e condições de Poker"
  ],
  "Postal address": [
    null,
    "Morada"
  ],
  "Postal code": [
    null,
    "Código postal"
  ],
  "Privacy Policy": [
    null,
    "Política de Privacidade"
  ],
  "Processing": [
    null,
    "A processar"
  ],
  "Protect your behind!": [
    null,
    "É melhor proteger-se!"
  ],
  "Protect<br />your<br />behind!": [
    null,
    "É<br />melhor<br />protreger-se!"
  ],
  "Province": [
    null,
    "Distrito"
  ],
  "RIB key": [
    null,
    "Chave IBAN"
  ],
  "Reference": [
    null,
    "Referência"
  ],
  "Referral": [
    null,
    ""
  ],
  "Referral code": [
    null,
    ""
  ],
  "Region of birth": [
    null,
    "Distrito de nascimento"
  ],
  "Register": [
    null,
    ""
  ],
  "Register with my email": [
    null,
    "Registar com o meu email"
  ],
  "Register with my phone number": [
    null,
    "Registar com o meu número de telefone"
  ],
  "Registration": [
    null,
    "Registar"
  ],
  "Registration complete!": [
    null,
    ""
  ],
  "Registration not allowed from this country of residence.": [
    null,
    "Não é possível registrar-se a partir deste país de residência."
  ],
  "Regular": [
    null,
    ""
  ],
  "Regular profile token": [
    null,
    ""
  ],
  "Residence permit: front and back": [
    null,
    "Licença de residência: frente e verso"
  ],
  "Responsible gaming": [
    null,
    "Jogo responsável"
  ],
  "SWIFT code": [
    null,
    "SWIFT "
  ],
  "Save this card for future deposits": [
    null,
    "Guardar este cartão para futuros depósitos"
  ],
  "Scan my ID": [
    null,
    "Digitalizar documento de identificação "
  ],
  "Scan my bank card": [
    null,
    "Digitalizar o meu cartão bancário "
  ],
  "Scan my verification document": [
    null,
    "Digitalizar o meu documento de verificação"
  ],
  "Search": [
    null,
    "Procurar"
  ],
  "See Ts&Cs for the offer": [
    null,
    "Ver Termos e Condições da oferta"
  ],
  "See accepted verification documents": [
    null,
    "Ver os documentos de verificação aceites"
  ],
  "See what IDs we accept": [
    null,
    "Ver que tipos de documentos de identificação são aceites"
  ],
  "Select your file": [
    null,
    "Selecionar o seu ficheiro"
  ],
  "Send ID": [
    null,
    ""
  ],
  "Send back of document": [
    null,
    "Enviar verso do documento"
  ],
  "Send documents": [
    null,
    "Enviar documentos"
  ],
  "Send my ID": [
    null,
    "Enviar o meu documento de identificação "
  ],
  "Send my new code": [
    null,
    "Enviar um novo código"
  ],
  "Send my verification documents": [
    null,
    "Enviar os meus documentos de verificação"
  ],
  "Send proof of identity": [
    null,
    ""
  ],
  "Sex": [
    null,
    "Sexo"
  ],
  "Show<br />us who<br />you are!": [
    null,
    "Diz-nos<br />quem<br />és!"
  ],
  "Skip this step": [
    null,
    "Saltar esta etapa "
  ],
  "Skrill email": [
    null,
    "Email Skrill"
  ],
  "Social security card": [
    null,
    "Cartão de segurança social"
  ],
  "Sports betting Terms and Conditions": [
    null,
    "Termos e Condições de Apostas desportivas "
  ],
  "Starting at €%1$s": [
    null,
    "A partir de %1$s €"
  ],
  "Successfully uploaded!": [
    null,
    "Carregado com sucesso!"
  ],
  "Super-player created!": [
    null,
    "Super-jogador criado!"
  ],
  "Surname": [
    null,
    "Segundo apelido"
  ],
  "Take 2 minutes to create your account.": [
    null,
    "Demora apenas 2 minutos para criar a sua conta."
  ],
  "Tax Code": [
    null,
    "Número de identificação fiscal (NIF)"
  ],
  "Tax bill or home insurance letter": [
    null,
    "Documento de IRS ou seguro de casa."
  ],
  "Terms and Conditions": [
    null,
    "Termos e Condições"
  ],
  "The activation code cannot be over %1$s characters.": [
    null,
    "O código de validação não pode ultrapassar %1$s caracteres. "
  ],
  "The activation code is not valid.": [
    null,
    "O código de ativação não é válido."
  ],
  "The best odds are your odds": [
    null,
    "As melhores cotas são as suas cotas"
  ],
  "The current process seems to be slow. Try again.": [
    null,
    "O processo parece estar lento. Tente novamente."
  ],
  "The identity verification service is unavailable. Please try again later.": [
    null,
    "O serviço de verificação de identidade encontra-se indisponível. Por favor, tente mais tarde."
  ],
  "The maximum amount of time (in hours) you can spend at the poker tables each week.": [
    null,
    ""
  ],
  "The maximum amount of your balance (bankroll) above which any additional winnings will be transferred directly to your bank account. Your account must be validated beforehand and we will need your bank details.": [
    null,
    ""
  ],
  "The maximum amount you can deposit into your account each week for sports betting and poker.": [
    null,
    ""
  ],
  "The maximum cumulative amount you can bet on poker each week.": [
    null,
    ""
  ],
  "The maximum cumulative amount you can bet on sports betting each week.": [
    null,
    ""
  ],
  "The welcome bonus is linked to your first deposit. Set an amount of €100 (or more) to maximise your bonus!": [
    null,
    ""
  ],
  "There already exists an account with this email address.": [
    null,
    "Já existe uma conta com este endereço de email."
  ],
  "These deposit methods are not available for this amount.": [
    null,
    "Estes métodos de depósito não estão disponíveis para este montante"
  ],
  "This code is required to create your account.": [
    null,
    "Este código é necessário para criar a sua conta"
  ],
  "This field is mandatory to validate your deposit.": [
    null,
    "Este campo é obrigatório para validar o seu depósito."
  ],
  "This file format is invalid. Please try in one of the following formats: %1$s.": [
    null,
    "Formato de ficheiro inválido. Por favor, escolha um dos formatos seguintes: %1$s."
  ],
  "This fiscal code is already linked to an active account": [
    null,
    "Este NIF já se encontra associado a uma conta ativa"
  ],
  "This limit can be changed at any time in your account.": [
    null,
    ""
  ],
  "This limit is mandatory for your account validation.": [
    null,
    "Este limite é obrigatório para validar a sua conta."
  ],
  "This password does not contain at least 3 of the following: (0-9), (a-z), (A-Z) and symbols (e.g. @, !, #, $)": [
    null,
    "Esta palavra-passe não contem pelo menos um dos três elementos seguintes: (0-9), (a-z), (A-Z) e símbolos (ex @, !, #, $)"
  ],
  "This referral code is not valid.": [
    null,
    ""
  ],
  "This threshold can be changed at any time from your account.": [
    null,
    ""
  ],
  "This username is unavailable.": [
    null,
    "Este nome de utilizador não está disponível."
  ],
  "This way for<br />money": [
    null,
    "Por aqui para o<br />dinheiro"
  ],
  "Too many attempts with this identity. Please try again later.": [
    null,
    "Realizou demasiadas tentativas com uma identidade errada. Por favor tente novamente mais tarde. "
  ],
  "Try again": [
    null,
    "Tente novamente "
  ],
  "Ts&Cs": [
    null,
    "Termos e Condições"
  ],
  "Ts&Cs for the offer": [
    null,
    "Termos e Condições da oferta "
  ],
  "Type of cash-out": [
    null,
    "Tipo de levantamento"
  ],
  "Type of document": [
    null,
    "Tipo de documento"
  ],
  "Unable to load profile information.": [
    null,
    "Não foi possível carregar os dados do seu perfil."
  ],
  "Unable to send verification message.": [
    null,
    "Não é possível enviar mensagem de verificação."
  ],
  "Unauthorised email.": [
    null,
    "O teu email não está autorizado."
  ],
  "Up to": [
    null,
    "Até"
  ],
  "Up to a limit of €100 or the same amount as your first deposit": [
    null,
    ""
  ],
  "Up to €100 free, instantly!": [
    null,
    "1ª aposta reembolsada até 100€"
  ],
  "Upload an identity document to continue registration.": [
    null,
    ""
  ],
  "Upload my ID": [
    null,
    "Enviar o meu documento de identificação "
  ],
  "Upload my verification document": [
    null,
    "Enviar o meu documento de verificação"
  ],
  "Use France Connect": [
    null,
    "Use France Connect"
  ],
  "Use my existing deposit limit. If none is available, the limit set by you above will be applied.": [
    null,
    ""
  ],
  "Used or married name": [
    null,
    ""
  ],
  "Username": [
    null,
    "Nome de utilizador"
  ],
  "Validate": [
    null,
    "Validar"
  ],
  "Validate my deposit": [
    null,
    "Validar o meu depósito"
  ],
  "Validate my information": [
    null,
    "Validar as minhas informações"
  ],
  "Validate my limit": [
    null,
    "Validar o meu limite"
  ],
  "Validate my username": [
    null,
    "Validar o meu nome de utilizador"
  ],
  "Validation code": [
    null,
    "Código de validação"
  ],
  "Verification": [
    null,
    "Verificação"
  ],
  "Verify your phone number to receive a new text message with your validation code.": [
    null,
    "Verifique o seu número de telefone para receber uma nova SMS com o seu código de validação."
  ],
  "Want to start playing? Make a deposit now.": [
    null,
    ""
  ],
  "Want to<br />create a<br />username?": [
    null,
    "Quer criar <br />um nome<br />para si próprio?"
  ],
  "We are also offering a bonus of equal value to your first deposit.": [
    null,
    "Estamos também a oferecer um bónus de valor igual ao seu primeiro depósito."
  ],
  "We cannot accept land-line numbers.": [
    null,
    "Não podemos aceitar números fixos"
  ],
  "We will refund your 1st bet up to €100.": [
    null,
    "A Winamax reembolsa a sua primeira aposta até 100€"
  ],
  "We're fetching your data...": [
    null,
    "Estamos a recuperar as suas informações... "
  ],
  "Weekly betting limits": [
    null,
    ""
  ],
  "Welcome bonus": [
    null,
    ""
  ],
  "Welcome to Winamax": [
    null,
    ""
  ],
  "Welcome<br />to<br />Winamax!": [
    null,
    "Bem-vindo <br />à<br />Winamax!"
  ],
  "What is France Connect": [
    null,
    "O que é France Connect"
  ],
  "With 168h per week, you can play for an unlimited period": [
    null,
    ""
  ],
  "Withdrawable cash credited to your account directly after the result of the first bet": [
    null,
    ""
  ],
  "You are already registered.": [
    null,
    "Já está registado."
  ],
  "You are not authorized to access this service.": [
    null,
    "Não está autorizado a aceder a este serviço."
  ],
  "You are not permitted to create an account from this country.": [
    null,
    "Não pode criar uma conta a partir deste país. "
  ],
  "You are not permitted to create this user account.": [
    null,
    "Não pode criar esta conta de utilizador. "
  ],
  "You are on the Interior Ministry's banned player list!": [
    null,
    "Encontra-se na lista de interditos de jogar!"
  ],
  "You can change this option at any time from your account": [
    null,
    ""
  ],
  "You can continue playing on Winamax in the meantime.": [
    null,
    "Entretanto pode continuar a jogar na Winamax."
  ],
  "You can finally risk it for that big accumulator!": [
    null,
    "Pode finalmente arriscar aquela grande aposta acumulada!"
  ],
  "You can only upload one file at a time. Choose wisely!": [
    null,
    "Apenas pode enviar um ficheiro de cada vez. Escolha bem!"
  ],
  "You can send this to us at a later time, but you must enter your information now.": [
    null,
    "Pode fazê-lo mais tarde, mas tem de introduzir os seus dados agora."
  ],
  "You cannot create an account from your country.": [
    null,
    "Não pode criar uma conta a partir do seu país"
  ],
  "You have already transferred this file.": [
    null,
    "Já transferiu este ficheiro."
  ],
  "You have entered an invalid domiciliation code": [
    null,
    "Introduziu um código de domicílio inválido"
  ],
  "You have entered an invalid phone number.": [
    null,
    "Introduziu um número de telefone inválido"
  ],
  "You have insufficient CAPTCHA score to continue. Please try again later.": [
    null,
    "O seu resultado CAPTCHA não foi suficiente para continuar. Por favor, tente novamente mais tarde."
  ],
  "You have successfully added your identity document. Please ensure the information you have entered is correct and fill out your postal address.": [
    null,
    "Adicionou com sucesso o seu documento de identificação . Por favor confira se as informações introduzidas estão corretas e preencha a sua morada"
  ],
  "You have successfully made a request to change your password. Please check your emails.": [
    null,
    "Solicitou a alteração da sua palavra-passe. Por favor, verifique o seu email."
  ],
  "You must accept our Ts&Cs in order to create your account.": [
    null,
    "Tem de aceitar os nossos Termos e Condições de forma a criar a sua conta "
  ],
  "You must choose a betting stakes limit in order to start playing.": [
    null,
    ""
  ],
  "You must choose a deposit limit in order to make a deposit.": [
    null,
    "Tem de escolher um limite de depósito de forma a poder realizar um depósito."
  ],
  "You must choose a password.": [
    null,
    "Tem de escolher uma palavra-passe"
  ],
  "You must choose a playtime limit in order to start playing.": [
    null,
    ""
  ],
  "You must choose a poker stakes limit in order to start playing.": [
    null,
    ""
  ],
  "You must choose an automatic withdrawal limit in order to start playing.": [
    null,
    ""
  ],
  "You must choose an option for your sex in order to create your account.": [
    null,
    "Deve indicar o seu sexo para poder criar uma conta."
  ],
  "You must enter a deposit amount.": [
    null,
    "Tem de introduzir um montante a depositar."
  ],
  "You must enter an email or a phone number.": [
    null,
    "Deve introduzir um email ou um número de telefone."
  ],
  "You must enter the full name displayed on your bank card in order to validate your deposit.": [
    null,
    "Deve introduzir o nome completo inscrito no seu cartão bancário de forma a validar o seu depósito."
  ],
  "You must enter your activation code in order to validate your account.": [
    null,
    "Deve introduzir o seu código de ativação de forma a validar a sua conta."
  ],
  "You must enter your bank card cryptogram in order to validate your deposit.": [
    null,
    "Deve introduzir o criptograma do seu cartão bancário de forma a validar o seu depósito."
  ],
  "You must enter your bank card expiry date in order to validate your deposit.": [
    null,
    "Deve introduzir a data de expiração do seu cartão bancário de forma a validar o seu depósito"
  ],
  "You must enter your bank card number in order to validate your deposit.": [
    null,
    "Deve introduzir o número do seu cartão bancário de forma a validar o seu depósito."
  ],
  "You must enter your city of birth in order to create your account.": [
    null,
    "Deve indicar-nos a sua naturalidade de forma a poder criar a sua conta"
  ],
  "You must enter your city of residence in order to create your account.": [
    null,
    "Deve indicar-nos a sua cidade de residência de forma a poder criar a sua conta"
  ],
  "You must enter your country of birth in order to create your account.": [
    null,
    "Deve indicar-nos o seu país de nascimento de forma a poder criar a sua conta"
  ],
  "You must enter your country of residence in order to create your account.": [
    null,
    "Deve indicar-nos o seu país de residência de forma a poder criar a sua conta"
  ],
  "You must enter your date of birth in order to create your account.": [
    null,
    "Deve indicar-nos a sua data de nascimento de forma a poder criar a sua conta"
  ],
  "You must enter your department of birth in order to create your account.": [
    null,
    "Tem de introduzir o seu distrito de nascimento de forma a criar a sua conta"
  ],
  "You must enter your email in order to create your account.": [
    null,
    "Tem de introduzir o seu email de forma a criar a sua conta"
  ],
  "You must enter your phone number in order to create your account.": [
    null,
    "Tem de introduzir o seu número de telefone de forma a criar a sua conta."
  ],
  "You must enter your postal address in order to create your account.": [
    null,
    "Deve indicar-nos a sua morada de forma a poder criar a sua conta"
  ],
  "You must enter your postal code in order to create your account.": [
    null,
    "Deve indicar-nos o seu código postal de forma a poder criar a sua conta"
  ],
  "You must enter your province to create your account.": [
    null,
    "Tem de indicar o seu distrito para criar a sua conta."
  ],
  "You must not be connected to the Winamax Poker software (desktop or mobile)": [
    null,
    "Não deve estar conectado ao software de poker Winamax (desktop ou móvel)"
  ],
  "You must provide your first name in order to create your account.": [
    null,
    "Deve indicar-nos o seu nome de forma a poder criar a sua conta."
  ],
  "You must provide your last name in order to create your account.": [
    null,
    "Deve indicar-nos o seu apelido de forma a poder criar a sua conta"
  ],
  "You must provide your second last name in order to create your account.": [
    null,
    ""
  ],
  "You need a username to play on Winamax.": [
    null,
    "Necessita de um nome de utilizador para jogar na Winamax."
  ],
  "You need to provide us with your ID and proof of address in order to complete your registration.": [
    null,
    "Deve fornecer-nos o seu documento de identificação e justificativo de residência de forma a completar a sua inscrição "
  ],
  "You need to provide us with your ID in order to complete your registration.": [
    null,
    "Deve fornecer-nos o seu documento de identificação de forma a completar a sua inscrição."
  ],
  "You will receive an activation code by post at the following address:": [
    null,
    "Irá receber um código de ativação via correio na morada seguinte:"
  ],
  "You're too old!": [
    null,
    "É demasiado velho!"
  ],
  "You're too young!": [
    null,
    "És demasiado jovem!"
  ],
  "You're way too young!": [
    null,
    "É demasiado jovem!"
  ],
  "Your ID could not be analyzed but it has been registered. Please enter your information whilst waiting for your document to be verified.": [
    null,
    "Não foi possível analisar o seu documento de identificação, mas este foi registado. Por favor, introduza as suas informações enquanto aguarda pela verificação deste."
  ],
  "Your ID upload has encountered an error": [
    null,
    "Ocorreu um erro a enviar o seu documento de identificação"
  ],
  "Your ID was registered successfully": [
    null,
    "O seu documento de identificação foi registrado com sucesso"
  ],
  "Your account is frozen.": [
    null,
    "A sua conta está bloqueada."
  ],
  "Your account is reloaded,<br /><b>you can continue playing on Winamax</b>": [
    null,
    "A sua conta foi recarregada<br /><b>, pode continuar a jogar na Winamax </b>"
  ],
  "Your account validation is being processed. You will be notified when your documents have been validated.": [
    null,
    "A validação da sua conta está a ser processada. Será notificado assim que os seus documentos sejam validados."
  ],
  "Your address is not valid.": [
    null,
    "A sua morada não é válida."
  ],
  "Your automatic withdrawal limit cannot be over %1$s digits.": [
    null,
    "O seu limite de levantamento automático não deve ser superior a %1$s dígitos."
  ],
  "Your automatic withdrawal limit is too big.": [
    null,
    ""
  ],
  "Your automatic withdrawal limit must be greater than or equal to your deposit limit.": [
    null,
    ""
  ],
  "Your automatic withdrawal limit must be more than €200.": [
    null,
    ""
  ],
  "Your automatic withdrawal limit must be over €0.": [
    null,
    "O seu limite de levantamento automático deve ser superior a 0€."
  ],
  "Your bank card cryptogram is not valid.": [
    null,
    "O criptograma do seu cartão bancário não é válido."
  ],
  "Your bank card expiry date is not valid.": [
    null,
    "A data de expiração do seu catão bancário não é válida."
  ],
  "Your bank card number is not valid": [
    null,
    "O número do seu cartão bancário não é válido."
  ],
  "Your bet refunded in": [
    null,
    ""
  ],
  "Your betting stakes limit is too big.": [
    null,
    ""
  ],
  "Your betting stakes limit must be more than €0.": [
    null,
    ""
  ],
  "Your betting stakes limit per week is not valid.": [
    null,
    "O seu limite de apostas desportivas semanal não é válido. "
  ],
  "Your city cannot be over %1$s characters.": [
    null,
    "A sua cidade não pode ter mais que %1$s caracteres."
  ],
  "Your city is not valid.": [
    null,
    "A sua cidade não é válida."
  ],
  "Your city is required.": [
    null,
    "É necessária a sua cidade."
  ],
  "Your city of birth cannot be over %1$s characters.": [
    null,
    "A sua naturalidade não pode ter mais de %1$s caracteres."
  ],
  "Your city of birth is not valid.": [
    null,
    "A sua naturalidade não é válida. "
  ],
  "Your coordinates": [
    null,
    "As suas informações"
  ],
  "Your country cannot be over %1$s characters.": [
    null,
    "O seu país não pode ter mais que %1$s caracteres"
  ],
  "Your country is not valid.": [
    null,
    "O seu país não é válido."
  ],
  "Your country is required.": [
    null,
    "É necessário o seu país."
  ],
  "Your country of birth is not valid.": [
    null,
    "O seu país de nascimento não é válido."
  ],
  "Your date of birth is not valid.": [
    null,
    "Data de nascimento inválida."
  ],
  "Your date of birth must include 4 numbers.": [
    null,
    "A sua data de nascimento deve conter 4 números"
  ],
  "Your department of birth cannot be over %1$s characters.": [
    null,
    "O seu distrito de nascimento não pode ter mais de %1$s caracteres."
  ],
  "Your department of birth is not valid.": [
    null,
    "O seu distrito de nascimento não é válido."
  ],
  "Your deposit cannot be more than your weekly deposit limit: €%1$s.": [
    null,
    "O montante do seu depósito não pode ser superior ao seu limite de depósito semanal: %1$s € ."
  ],
  "Your deposit limit has been registered. <b>in 48 hours, you will be able to make larger deposits</b>": [
    null,
    "O seu limite de depósito foi registado. <b>Em 48horas, pode realizar depósitos maiores </b>"
  ],
  "Your deposit limit is too big.": [
    null,
    "O seu limite de depósito é demasiado alto."
  ],
  "Your deposit limit must be more than €0.": [
    null,
    "O seu limite de depósito deverá ser superior a 0€"
  ],
  "Your deposit limit per week is not valid.": [
    null,
    "O seu limite de depósito semanal não é válido."
  ],
  "Your deposit must be over €0.": [
    null,
    "O depósito deverá ser superior a 0€"
  ],
  "Your document failed to upload": [
    null,
    "Ocorreu um erro a enviar o seu documento"
  ],
  "Your email cannot be over %1$s characters.": [
    null,
    "O seu email não pode ter mais de %1$s caracteres"
  ],
  "Your email is not valid.": [
    null,
    "O seu email não é válido"
  ],
  "Your file is too big. Try again with a file smaller than %1$s Mb.": [
    null,
    "O seu ficheiro é demasiado grande. Tente novamente com um ficheiro menor que %1$s Mb."
  ],
  "Your first bet refunded in cash if it loses": [
    null,
    ""
  ],
  "Your first name cannot be over %1$s characters.": [
    null,
    "O seu nome não pode ter mais de %1$s caracteres."
  ],
  "Your first name is not valid.": [
    null,
    "O seu nome não é válido. "
  ],
  "Your identity": [
    null,
    "A sua identidade"
  ],
  "Your identity corresponds to that of a minor.": [
    null,
    "A sua identidade corresponde à de uma pessoa menor de idade."
  ],
  "Your identity corresponds to that of someone who has been registered as being deceased.": [
    null,
    "A sua identidade corresponde à de uma pessoa registada como falecida."
  ],
  "Your information is being processed!": [
    null,
    "A sua informação está a ser processada!"
  ],
  "Your initial deposit in Freebets, up to €100*": [
    null,
    "O seu depósito inicial em Freebets até 100€*"
  ],
  "Your last name cannot be over %1$s characters.": [
    null,
    "O seu apelido não pode ter mais de %1$s caracteres."
  ],
  "Your last name is not valid.": [
    null,
    "O seu apelido não é válido."
  ],
  "Your limit cannot be €0": [
    null,
    "O seu limite não pode ser 0€"
  ],
  "Your limit for %1$s must be inferior or equal to %2$s": [
    null,
    ""
  ],
  "Your limit for %1$s must be set between %2$s and %3$s": [
    null,
    ""
  ],
  "Your limit for %1$s must be superior or equal to %2$s": [
    null,
    ""
  ],
  "Your limit for %1$s must be superior or equal to your %2$s limit": [
    null,
    ""
  ],
  "Your limit must be inferior or equal to %1$s": [
    null,
    "O seu limite deve ser inferior ou igual a %1$s"
  ],
  "Your limit must be set between %1$s and %2$s": [
    null,
    "O seu limite deve estar compreendido entre %1$s e %2$s"
  ],
  "Your limit must be superior or equal to %1$s": [
    null,
    "O seu limite deve ser maior ou igual a %1$s"
  ],
  "Your name in the rankings will be:": [
    null,
    "O seu nome na classificação é:"
  ],
  "Your number will only be used to identify you": [
    null,
    "O seu número será utilizado apenas para o identificar"
  ],
  "Your password cannot be over %1$s characters.": [
    null,
    "A sua palavra passe não pode ter mais de %1$s caracteres."
  ],
  "Your password is not valid.": [
    null,
    "A sua palavra-passe não é válida"
  ],
  "Your password must contain at least %1$s characters.": [
    null,
    "A sua palavra-passe deve conter pelo menos %1$s caracteres"
  ],
  "Your payment": [
    null,
    "O seu pagamento "
  ],
  "Your phone number is mandatory in order to receive a new code.": [
    null,
    "O seu número de telefone é essencial para receber um novo código."
  ],
  "Your playtime limit must be more than 0 hours.": [
    null,
    ""
  ],
  "Your poker stakes limit is too big.": [
    null,
    ""
  ],
  "Your poker stakes limit must be more than €0.": [
    null,
    ""
  ],
  "Your poker stakes limit per week is not valid.": [
    null,
    "O seu limite de apostas de poker semanal não é válido. "
  ],
  "Your postal address cannot be over %1$s characters.": [
    null,
    "A sua morada não pode ter mais que %1$s caracteres. "
  ],
  "Your postal address is required.": [
    null,
    "É necessário a sua morada."
  ],
  "Your postal code cannot be over %1$s characters.": [
    null,
    "O seu código postal não pode ter mais que %1$s caracteres"
  ],
  "Your postal code is required.": [
    null,
    "É necessário o seu código postal. "
  ],
  "Your proof of address cannot be over one year old.": [
    null,
    "O seu comprovativo de residência não pode ter mais de um ano."
  ],
  "Your session has expired.": [
    null,
    "A sua sessão expirou."
  ],
  "Your state is not valid.": [
    null,
    "O seu distrito não é válido."
  ],
  "Your story begins here!": [
    null,
    ""
  ],
  "Your turn to play": [
    null,
    "É a sua vez de jogar"
  ],
  "Your turn<br />to play": [
    null,
    "A sua vez <br />de jogar "
  ],
  "Your username cannot contain over %1$s characters.": [
    null,
    "O seu nome de utilizador deve conter no máximo %1$s caracteres."
  ],
  "Your username is not valid, the only authorized special characters are: .&_- and space.": [
    null,
    "O seu nome de utilizador não é válido. Os únicos caracteres especiais autorizados são: .&_- e espaço."
  ],
  "Your username must contain at least %1$s characters.": [
    null,
    "O seu nome de utilizador deve conter no mínimo %1$s caracteres."
  ],
  "Your validation code is incorrect.": [
    null,
    "O seu código de validação esta incorreto."
  ],
  "Your zip code is not valid.": [
    null,
    "O seu código postal não e válido."
  ],
  "Your zip code of birth is not valid.": [
    null,
    "O seu local de nascimento está incorreto."
  ],
  "and": [
    null,
    ""
  ],
  "as well as our": [
    null,
    ""
  ],
  "is being processed...": [
    null,
    "está a ser processado..."
  ],
  "of a super-player in progress...": [
    null,
    "de um super-jogador a decorrer… "
  ],
  "of the ongoing payment...": [
    null,
    "do pagamento em curso..."
  ],
  "of your bank card processing...": [
    null,
    "do seu cartão bancário… "
  ],
  "or": [
    null,
    "ou"
  ],
  "poker": [
    null,
    ""
  ],
  "promotions": [
    null,
    ""
  ],
  "sports betting": [
    null,
    ""
  ],
  "your document upload...": [
    null,
    "o seu documento carregado..."
  ]
}
  }
}
